import { FC } from 'react';

import { useTranslation } from 'next-i18next/pages';

import { Col, Row } from 'antd';
import classNames from 'classnames';

import { ApplicationButton } from '@/components/CreateApplication/ApplicationButton/ApplicationButton';
import {
	getAddApplicationButtons,
	getExtraApplicationButtons,
	getTransferApplicationButtons,
} from '@/components/CreateApplication/config';
import { CreateApplicationProps } from '@/components/CreateApplication/types';
import { TranslationNamespace } from '@/i18n';

import styles from './CreateApplicationBlock.module.scss';

export const CreateApplicationBlock: FC<CreateApplicationProps> = ({
	warehouseId,
	warehouseTitle,
	virtual,
	compact,
	hideExtra,
	hasProducts,
}) => {
	const { t } = useTranslation(TranslationNamespace.WarehouseSearch);
	const { t: tApplications } = useTranslation(TranslationNamespace.Applications);
	const storageQuery = warehouseId ? `?warehouseId=${warehouseId}` : '';
	const storageQueryLegacy = warehouseTitle ? `?name=${warehouseTitle}` : '';

	const addApplications = getAddApplicationButtons(storageQuery, tApplications);
	const transferApplications = getTransferApplicationButtons(storageQuery, tApplications);
	const extraApplications = hideExtra
		? []
		: getExtraApplicationButtons(storageQuery, storageQueryLegacy, tApplications).filter((btn) =>
				btn.key === 'service' ? !virtual : true,
			);
	const applications = [...addApplications, ...transferApplications, ...extraApplications];

	return (
		<div className={classNames(styles.container, compact && styles.compact)}>
			<div className={styles.title}>{t('storage-page.create-application-for-warehouse')}</div>
			<Row gutter={[12, 12]}>
				{applications.map((btn) => {
					const isActiveButton =
						btn.key === 'transfer' || btn.key === 'shipment' ? hasProducts : true;
					return (
						<Col xs={24} md={8} lg={8} xl={8} key={btn.key}>
							<ApplicationButton {...btn} isActive={isActiveButton} />
						</Col>
					);
				})}
			</Row>
		</div>
	);
};
